export default class Config  {
  // Префикс URL с основным API приложения. Используется только для
  // проксирования запросов сервером разработки и не виляет на собранный код.
  public static API_PREFIX: string = 'https://magnit-dev.bsl.dev/api/'
  // Путь от которого стартует приложение для history api
  public static ROOT_PATH: string =  '/'
  // Порт для dev сервера
  public static DEV_PORT: Number = 9000
  // Урл для яндекс карт
  public static YMAPS: string = "https://api-maps.yandex.ru/2.1/?lang=ru_RU"
};
